





























import { Inject, Prop, Component, Vue } from 'vue-property-decorator'
import { WinckOffice } from '@/api/client/winck-proxy'
import { namespace } from 'vuex-class'
import { cloneDeep } from 'lodash'
const narrowcasting = namespace('narrowcasting')

@Component
export default class CompanySettingsNarrowcastingOfficesEdit extends Vue {
    @Prop({ required: true }) readonly officeId!: string
    @Inject() readonly navigateToList: () => Promise<void>
    @narrowcasting.State readonly saving!: boolean
    @narrowcasting.State readonly offices!: WinckOffice[]
    @narrowcasting.Action readonly updateOffice: (office: WinckOffice) => Promise<void>
    office: WinckOffice = null

    mounted() {
        const office = this.offices.find(v => v.id === this.officeId)
        if (office) {
            this.office = cloneDeep<WinckOffice>(office)
        }
    }

    async onSave(): Promise<void> {
        await this.updateOffice(this.office)
        await this.navigateToList()
    }

    async onCancel(): Promise<void> {
        await this.navigateToList()
    }
}
